export default "__VITE_ASSET__DRwbq_Cj__"